import axiosClient from "./axios";
import axiosImage from "./axiosImage";

export const postTimeCapsule = async (data) => {
  try {
    const response = await axiosClient.post(`/module/time-capsule/create`, data);
    return response.data;
  } catch (error) {
    console.error("Zaman kapsülü kaydedilirken hata:", error);
    throw error;
  }
};

export const postTimeCapsulePhoto = async (photo, uuid) => {
  try {
    const formData = new FormData();
    formData.append('photo', photo);
    
    const response = await axiosImage.post(`/api/module/time-capsule/` + uuid + `/upload-photo`, formData);
    return response.data;
  } catch (error) {
    console.error("Zaman kapsülü fotoğrafı kaydedilirken hata:", error);
    throw error;
  }
};

export const getTimeCapsule = async (uuid) => {
  try {
    const response = await axiosClient.get(`/module/time-capsule/`+ uuid);
    return response.data;
  } catch (error) {
    console.error("Zaman kapsülü alınırken hata:", error);
    throw error;
  }
};

export const getTimeCapsuleList = async () => {
  try {
    const response = await axiosClient.get(`/module/time-capsule/list` );
    return response.data;
  } catch (error) {
    console.error("Zaman kapsülü listesi alınırken hata:", error);
    throw error;
  }
};

// Yeni tek API - action: 1=kabul et, 2=aç, 3=sil
export const updateTimeCapsuleStatus = async (uuid, action) => {
  try {
    const response = await axiosClient.post(`/module/time-capsule/${uuid}/update`, { action });
    return response.data;
  } catch (error) {
    console.error("Zaman kapsülü durumu güncellenirken hata:", error);
    throw error;
  }
};

// Geriye uyumluluk için wrapper fonksiyonlar
export const deleteTimeCapsule = async (uuid) => {
  return updateTimeCapsuleStatus(uuid, 3);
};

export const updateTimeCapsule = async (uuid) => {
  return updateTimeCapsuleStatus(uuid, 1);
};

export const postUnlockTimeCapsule = async (uuid) => {
  return updateTimeCapsuleStatus(uuid, 2);
};

